import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ReactTable from 'react-table-6';
import { Add } from "@mui/icons-material";
import ModuleHeader from "./ModuleHeader";
import ModuleFilters from "./ModuleFilters";
import ModulePagination from "./ModulePagination";
import DeleteModuleModal from "./DeleteModuleModal";
import { useModules } from "./useModules";
import { createModuleTableColumns } from "./ModuleTableColumns";
import { toggleModal } from "../../../../reducers/modalReducer";

const ModuleList = ({ onCreate, onView, onEdit, onGenerateAI }) => {
    const dispatch = useDispatch();
    const [deleteModule, setDeleteModule] = useState(null);
    const {
        moduleList,
        totalModules,
        totalPages,
        currentPage,
        pageSize,
        isLoading,
        sortField,
        sortOrder,
        statusFilter,
        categoryFilter,
        typeFilter,
        handleSearchChange,
        handleSort,
        handlePageChange,
        handlePageSizeChange,
        handleStatusFilterChange,
        handleCategoryFilterChange,
        handleTypeFilterChange,
        activeModule,
        deleteModule: deleteModuleAPI
    } = useModules();

    const handleActivate = (module) => {
        activeModule(module['_id'], module['moduleName'], !module['isActive']);
    };

    const handleDelete = (module) => {
        setDeleteModule(module);
        dispatch(toggleModal({ open: 'confirmDeleteModuleSection' }));
    };

    const handleDeleteConfirm = () => {
        if (deleteModule && deleteModule._id) {
            deleteModuleAPI(deleteModule._id);
            setDeleteModule(null);
        }
    };

    const handleDeleteModalClose = () => {
        setDeleteModule(null);
        dispatch(toggleModal({ open: '' }));
    };

    const columns = createModuleTableColumns(
        sortField,
        sortOrder,
        handleSort,
        onView,
        onEdit,
        handleActivate,
        handleDelete,
        onGenerateAI
    );

    return (
        <div className="modules-container">
            <ModuleHeader onCreateModule={onCreate} />

            <ModuleFilters
                onSearchChange={handleSearchChange}
                statusFilter={statusFilter}
                onStatusFilterChange={handleStatusFilterChange}
                categoryFilter={categoryFilter}
                onCategoryFilterChange={handleCategoryFilterChange}
                typeFilter={typeFilter}
                onTypeFilterChange={handleTypeFilterChange}
            />

            <div className="modules-table-card">
                <div className="modules-table-header-row df jcsb aic mb1rem">
                    <h3 className="modules-table-title">Modules ({totalModules})</h3>
                </div>

                {isLoading ? (
                    <div className="df jcc aic p4rem">
                        <div className="loader"></div>
                        <span className="ml1rem fs1rem c15">Loading modules...</span>
                    </div>
                ) : moduleList && moduleList.length > 0 ? (
                    <>
                        <div className="modules-table-wrapper">
                            <ReactTable
                                minRows={0}
                                className="modules-table"
                                data={moduleList}
                                resolveData={module => module.map(row => row)}
                                columns={columns}
                                showPagination={false}
                                resizable={false}
                            />
                        </div>
                        <ModulePagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            totalModules={totalModules}
                            pageSize={pageSize}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </>
                ) : (
                    <div className="df fdc aic jcc p4rem">
                        <p className="fs1-25rem c15 fw500 mb1rem">No modules found</p>
                        <button
                            onClick={onCreate}
                            className="modules-create-btn df aic jcc cp"
                        >
                            <Add style={{ fontSize: '18px', marginRight: '8px' }} />
                            Create Your First Module
                        </button>
                    </div>
                )}
            </div>

            <DeleteModuleModal
                moduleName={deleteModule?.moduleName || ''}
                onConfirm={handleDeleteConfirm}
                onClose={handleDeleteModalClose}
            />
        </div>
    );
};

export default ModuleList;
